(function () {
    'use strict';

    angular
    .module('szallodak-searchadmin', ['angularjs-dropdown-multiselect', 'ui.bootstrap']);
})();
